import { NameDto } from '../../Common/Types'
import { CurrencyType } from '../../Wallet/Types/Wallet'
import { symbols } from './IntroducingBrokerDetailedProfileDto'

export interface TradingAccountLotsProfitStatisticDto {
  tradingAccount: NameDto
  wallet: NameDto
  currency: {
    id: CurrencyType
    name: string
  }
  instrumentType: {
    id: number
    name: symbols
  }
  lots: number
  profit: number
}

export enum TradingAccountLotsProfitStatisticDtoKey {
  TRADING_ACCOUNT = 'tradingAccount.name',
  WALLET = 'wallet.name',
  CURRENCY = 'currency.id',
  INSTRUMENT_TYPE = 'instrumentType.name',
  LOTS = 'lots',
  PROFIT = 'profit',
}
